import imRequest from '../imRequest';
import { IM_API } from '../../constants/endpoints';

export const friendApi = {
  listFriends: () => imRequest.get(`${IM_API}/friends`),

  listRequests: (direction = 'incoming') =>
    imRequest.get(`${IM_API}/friends/requests`, { params: { direction } }),

  sendRequest: (toMemberId, message) =>
    imRequest.post(`${IM_API}/friends/requests`, { toMemberId, message }),

  accept: (id) => imRequest.post(`${IM_API}/friends/requests/${id}/accept`),

  reject: (id) => imRequest.post(`${IM_API}/friends/requests/${id}/reject`),

  cancel: (id) => imRequest.post(`${IM_API}/friends/requests/${id}/cancel`),

  removeFriend: (memberId) => imRequest.delete(`${IM_API}/friends/${memberId}`),
};

export const blockApi = {
  list: () => imRequest.get(`${IM_API}/blocks`),
  block: (memberId) => imRequest.post(`${IM_API}/blocks`, { memberId }),
  unblock: (memberId) => imRequest.delete(`${IM_API}/blocks/${memberId}`),
};

export const userSearchApi = {
  search: ({ keyword, exactUsername, limit } = {}) =>
    imRequest.get(`${IM_API}/users/search`, {
      params: { keyword, exactUsername, limit },
    }),
};
